import { getPackageDestination, selectPackageEntitlement } from '../../Service/packageEntitlements';

// 旧查询接口把尚未制作的附带 PPT 作为兑换页面链接返回，并非文件地址。
export function getPendingPptEntitlement(downloadUrl) {
    if (!downloadUrl) return null;
    try {
        const url = new URL(downloadUrl, window.location.origin);
        const code = url.searchParams.get('code')?.trim();
        if (url.pathname.replace(/\/$/, '') !== '/exchange' || !code) return null;
        return { redeemCode: code, redeemName: '答辩PPT', codeType: 2 };
    } catch {
        return null;
    }
}

export function beginPendingPpt(entitlement) {
    const destination = getPackageDestination(entitlement);
    selectPackageEntitlement(entitlement);
    window.location.assign(destination);
}
